import { gql } from '@apollo/client';
import {
  AssetFragment,
  AssetWithDimensionsFragment
} from '../../graphql/fragments/Asset';

export const ContentBlockFragment = gql`
  fragment ContentBlockFragment on ContentBlock {
    ... on ContentBlock {
      __typename
      backgroundColor
      content
      ctas {
        text
        url
      }
      customBackgroundColor
      icon {
        ...AssetFragment
      }
      id
      image {
        ...AssetWithDimensionsFragment
      }
      contentBlockImagePosition: imagePosition
      imageStyle
      contentBlockLayout: layout
    }
  }
  ${AssetFragment}
  ${AssetWithDimensionsFragment}
`;

export default {};
